import type { TrendDataset } from "./types";

/**
 * The datasets to chart: the ones the report declares (`trend`). Without a
 * declaration, the broadest rollup (the API lists the fewest records first)
 * is followed over time, and a rollup the work's rows name (a job's
 * technician) is ranked, else any other. What a dataset's icon is never
 * decides it: that is how it looks, not what the report is about.
 */
export const pickSeries = (
  datasets: TrendDataset[],
  /** The datasets the work's rows reference, in column order. */
  referenced: string[] = [],
) => {
  const declared = (trend: TrendDataset["trend"]) =>
    datasets.find((dataset) => dataset.trend === trend);
  const over = declared("over_time") ?? datasets[0];
  const ranked =
    declared("ranked") ??
    referenced
      .map((id) => datasets.find((dataset) => dataset.id === id))
      .find((dataset) => dataset && dataset !== over) ??
    datasets.find((dataset) => dataset !== over);
  return { over, ranked: ranked === over ? undefined : ranked };
};
